import { autoSyncer } from './autoSyncer.js';
import { getJsonData, getAnimScript } from './dataHelpers.js';


export function initEnergyFieldMini() {
    const loadData = getJsonData('app-energy-field-mini');

    var currentScene = loadData.currentScene || 1;
    var conf = loadData.conf || {};
    loadData.scene1Script = getAnimScript(loadData.scene1Script);
    loadData.scene2Script = getAnimScript(loadData.scene2Script);

    if (typeof modAnimationRun === 'undefined') {
        return;
    }
    const scene1Anim = new modAnimationRun({
        autoplay: currentScene == 1 ? true : false,
        prepare: true,
        groups: loadData.scene1Script.groups,
        animations: loadData.scene1Script.animations,

        animationContainer: '.sceneAnimation'
    }, $('.scene1').get(0));

    const scene2Anim = new modAnimationRun({
        autoplay: currentScene == 2 ? true : false,
        prepare: true,
        groups: loadData.scene2Script.groups,
        animations: loadData.scene2Script.animations,

        animationContainer: '.sceneAnimation'
    }, $('.scene2').get(0));


    const energySwitchTo = async (newScene, onShowStart) => {
            return new Promise((resolve, reject) => {
                if (newScene === currentScene) {
                    resolve();
                    return;
                }
                currentScene = newScene;

                const offIdx = currentScene === 1 ? 2 : 1;
                const onIdx = currentScene === 1 ? 1 : 2;
                const offAnim = currentScene === 1 ? scene2Anim : scene1Anim;
                const onAnim = currentScene === 1 ? scene1Anim : scene2Anim;

                const withoutAnimation = !$('.scene'+offIdx).is(':visible');

                $('.scene'+offIdx)
                    .stop(true, false)
                    .delay(withoutAnimation ? 0 : conf.off.delay)
                    .animate({
                        opacity: 0
                    }, withoutAnimation ? 0 : conf.off.speed, function () {
                        offAnim.togglePause(true);

                        if (onAnim.playStarted) {
                            onAnim.togglePause(false);
                        } else {
                            onAnim.playStart();
                        }
                        $('.scene'+onIdx)
                            .stop(true, false)
                            .delay(withoutAnimation ? 0 : conf.on.delay)
                            .animate({
                                opacity: 1
                            }, withoutAnimation ? 0 : conf.on.speed, function () {
                                resolve();
                            });

                        if (typeof onShowStart === 'function') {
                            onShowStart();
                        }
                    });
            });
        };

    addEnergyMiniCounter(loadData.connectSID, loadData.connectIID, loadData.iid, currentScene);

    addEventListener('energySwitchTo', (e) => {
        try {
            // @ts-ignore
            const { newScene, onShowStart, callback } = e.detail;
            energySwitchTo(newScene, onShowStart).then(() => {
                if (typeof callback === 'function') {
                    callback();
                }
            });
        } catch (error) {

        }
    });
}

export function addEnergyMiniCounter(connectSID, connectIID, iid, currentScene) {
    const id = 'cnti' + iid;
    const $counterContainer = $('.' + id);

    autoSyncer.setGlobal('connectSID', connectSID);
    autoSyncer.setGlobal('connectIID', connectIID);

    autoSyncer.add('energy-mini-counter', id, {
        counter: $counterContainer.data('cnt'),
        iid: iid,
        currentScene: currentScene
    }, function (itemData) {
        if (itemData.counterTT) {
            $counterContainer.attr('title', itemData.counterTT);
        }
        if (itemData.counter !== undefined) {
            $counterContainer.data('cnt', itemData.counter);
            return {
                counter: itemData.counter
            };
        }
        return false;
    });
}